import { config } from "~initializer/config.ts";

export const apiScopes = () => [config()?.backendClientId ?? ""];
